export default __webpack_public_path__ + "src/assets/generic.19107415a6035c5d03eb56e5a9963c2c.svg";